// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-491744e6] .closeBtn{display:none}[data-v-491744e6] .dialog-footer-inner{float:left !important}", ""]);
// Exports
module.exports = exports;
